var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { Disposer } from "../Infra/Disposer";
import { StudyStatus, StudyTranslationLanguage, StudyVersionStatus } from "healthex-common/study.dtos";
import { PreviewConsentMode, PreviewMetadata } from "healthex-common/preview.dtos";
export class InformedConsentExperienceViewModel {
    constructor(container) {
        this.disposer = new Disposer();
        this.studyVersions = NOT_LOADED;
        this.previewConsentDialogOpen = false;
        this.studiesUIManager = container.studiesUIManager;
        this.studyManager = container.studyManager;
        this.patientConsentUIManager = container.patientConsentUIManager;
    }
    run() {
        this.disposer.reaction(() => this.studiesUIManager.studyToManage, async () => {
            await this.loadStudyVersions();
        }, { fireImmediately: true });
    }
    stop() {
        this.disposer.dispose();
    }
    async loadStudyVersions() {
        if (!this.study || this.study === NOT_LOADED)
            return;
        this.studyVersions = await this.studyManager.getStudyVersions(this.study.id);
    }
    get study() {
        const study = this.studiesUIManager.studyToManage;
        if (study === NOT_LOADED)
            return NOT_LOADED;
        if (!study)
            return null;
        return study;
    }
    get studyVersionsToShow() {
        if (this.studyVersions === NOT_LOADED)
            return NOT_LOADED;
        return this.studyVersions.filter((version) => version.versionStatus !== StudyVersionStatus.DRAFT);
    }
    get showStudyVersions() {
        if (this.studyVersionsToShow === NOT_LOADED)
            return false;
        return this.studyVersionsToShow.length > 1;
    }
    get isProjectCompletedOrWithdrawn() {
        if (this.study === NOT_LOADED || this.study === null)
            return false;
        return [StudyStatus.COMPLETED, StudyStatus.WITHDRAWN].includes(this.study.status);
    }
    get showEditProjectButton() {
        return !this.isProjectCompletedOrWithdrawn;
    }
    async editProject() {
        await this.studiesUIManager.editProject();
    }
    async previewConsent(studyVersionId, previewConsentFlow) {
        if (!this.study || this.study === NOT_LOADED)
            return;
        await this.patientConsentUIManager.startInteractivePreview(this.study.id, studyVersionId, new PreviewMetadata({
            consentMode: PreviewConsentMode.REMOTE,
            consentFlow: previewConsentFlow,
            language: StudyTranslationLanguage.en,
        }));
        this.previewConsentDialogOpen = true;
    }
    hidePreviewConsent() {
        this.previewConsentDialogOpen = false;
    }
}
__decorate([
    observable
], InformedConsentExperienceViewModel.prototype, "studyVersions", void 0);
__decorate([
    observable
], InformedConsentExperienceViewModel.prototype, "previewConsentDialogOpen", void 0);
__decorate([
    computed
], InformedConsentExperienceViewModel.prototype, "study", null);
__decorate([
    computed
], InformedConsentExperienceViewModel.prototype, "studyVersionsToShow", null);
__decorate([
    computed
], InformedConsentExperienceViewModel.prototype, "showStudyVersions", null);
__decorate([
    computed
], InformedConsentExperienceViewModel.prototype, "isProjectCompletedOrWithdrawn", null);
__decorate([
    computed
], InformedConsentExperienceViewModel.prototype, "showEditProjectButton", null);
